<template>
  <div class="marketplace-list">
    <a-page-header :title="categoryName || 'Kategori'" @back="() => $router.push('/marketplace')" />
    <a-spin :spinning="loading">
      <a-row :gutter="[16, 16]" v-if="!loading">
        <a-col
          :xs="24"
          :sm="12"
          :md="6"
          :lg="6"
          :xl="6"
          v-for="app in filteredApps"
          :key="app.id">
          <router-link :to="`/marketplace/app/${app.slug}`" style="display:block">
            <a-card hoverable class="marketplace-list-card">
              <div class="card-content">
                <div class="card-icon-wrap">
                  <img v-if="app.icon" :src="app.icon" alt="icon" class="card-icon" />
                </div>
                <div class="card-title">{{ app.name }}</div>
                <div class="card-subtitle">Kolay Kurulum</div>
              </div>
            </a-card>
          </router-link>
        </a-col>
      </a-row>
      <a-empty v-if="!loading && filteredApps.length === 0" />
    </a-spin>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { csPortalApi } from '@/utils/csPortal'

export default {
  name: 'MarketPlaceList',
  setup () {
    const route = useRoute()
    const loading = ref(false)
    const apps = ref([])
    const categories = ref([])
    const categoryName = ref('')

    const filteredApps = computed(() => {
      const categorySlug = route.params.item
      const category = categories.value.find(cat => cat.slug === categorySlug)
      if (!category) return []
      return apps.value.filter(app => app.category_id === category.id)
    })

    const fetchData = async () => {
      loading.value = true
      try {
        const [appsRes, categoriesRes] = await Promise.all([
          axios.get(`${csPortalApi()}/marketplace/products`),
          axios.get(`${csPortalApi()}/marketplace/categories`)
        ])
        apps.value = appsRes.data
        categories.value = categoriesRes.data
        const categorySlug = route.params.item
        const category = categories.value.find(cat => cat.slug === categorySlug)
        categoryName.value = category ? category.name : categorySlug
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchData)

    return { loading, apps, categories, categoryName, filteredApps, fetchData }
  }
}
</script>

<style scoped>
.marketplace-list-card {
  min-height: 220px;
  border: 1px solid #e8e8e8;
}
.marketplace-list-card:hover {
  border-color: #d0d0d0;
}
.card-content {
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.card-icon-wrap {
  width: 100px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
}
.card-icon {
  width: 100px;
  min-height: 25px;
  max-height: 35px;
  object-fit: contain;
  object-position: left;
}
.card-title {
  color: #1890ff;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 8px;
}
.card-subtitle {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
}
.card-desc {
  color: #888;
  font-size: 15px;
  line-height: 1.4;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
